<template>
  <a-modal
    title="新建"
    :width="1080"
    :visible="visible"
    :confirmLoading="loading"
    @ok="() => { $emit('ok', this.data) }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]">
          <a-col :span="12">
            <a-form-item label="编号">
              <a-input v-decorator="['number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" />
            </a-form-item>
            <a-form-item label="交易品种">
              <a-select
                v-if="false"
                option-label-prop="tt"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="categoryFetching ? undefined : null"
                show-search
                allow-clear
                v-decorator="[
                  'category_id',
                  {
                    rules: [
                      { required: true, message: '必填项，请输入交易品种' },
                    ],
                  },
                ]"
                placeholder="请输入交易品种"
                :default-active-first-option="false"
                @search="this.categorySearch"
              >
                <a-spin v-if="categoryFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in categoryList" :key="d.id" :tt="d.name">
                  {{ d.name }}
                </a-select-option>
              </a-select>
              <a-tree-select
                style="width: 100%"
                allow-clear
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="categoryTreeData"
                v-decorator="[
                  'category_id',
                  {
                    rules: [
                      { required: true, message: '' },
                    ],
                  },
                ]"
                placeholder="请选择部门"
              >
              </a-tree-select>
            </a-form-item>
            <a-form-item label="参与人">
              <a-select
                mode="multiple"
                label-in-value
                v-decorator="[
                  'participant_ids',
                  {
                    rules: [
                      { required: true, message: '必填项，请输入参与人' },
                    ],
                  },
                ]"
                placeholder="参与人"
                style="width: 100%"
                :filter-option="false"
                :not-found-content="fetching ? undefined : null"
                @search="this.userSearch"
              >
                <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in userList" :key="d.user_id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="金蝶业务号编码">
              <a-input v-decorator="['jd_code', {rules: [{required: true, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
            <a-form-item label="待落实前提条件">
              <a-textarea v-decorator="['precondition', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" :auto-size="{ minRows: 2, maxRows: 3 }" placeholder="待落实前提条件"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="主体企业">
              <a-select
                option-label-prop="tt"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="corporationFetching ? undefined : null"
                show-search
                allow-clear
                v-decorator="[
                  'host_corporation_id',
                  {
                    rules: [
                      { required: true, message: '必填项，请输入主体企业' },
                    ],
                  },
                ]"
                placeholder="请输入主体企业"
                :default-active-first-option="false"
                @search="this.corporationSearch"
              >
                <a-spin v-if="corporationFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in corporationList" :key="d.id" :tt="d.name">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="名称">
              <a-input v-decorator="['name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="名称"/>
            </a-form-item>
            <a-form-item label="负责人">
              <a-select
                show-search
                v-decorator="[
                  'leader_id',
                  {
                    rules: [
                      { required: true, message: '必填项，请输入负责人' },
                    ],
                  },
                ]"
                placeholder="负责人"
                style="width: 100%"
                :filter-option="false"
                :not-found-content="leaderFetching ? undefined : null"
                @search="this.userLeaderSearch"
              >
                <a-spin v-if="leaderFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in userLeaderList" :key="d.user_id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="决策文件">
              <div class="clearfix" style="display: inline-block">
                <a-upload
                  v-decorator="['decision_files',{valuePropName: 'decision_files',rules: [{required: false, message: '必填项，请填写信息'}]}]"
                  name="file"
                  :action="actionUrl"
                  list-type="picture-card"
                  :file-list="fileList"
                  :data="new_multipart_params"
                  :before-upload="beforeUpload"
                  @preview="handlePreview"
                  @change="handleChange"
                >
                  <div v-if="fileList.length < 6">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">
                      文件上传
                    </div>
                  </div>
                </a-upload>
                <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                  <img alt="example" style="width: 100%" :src="previewImage" />
                </a-modal>
              </div>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import debounce from 'lodash/debounce'
import { corporation_list } from '@/api/trade_corporation'
import { category_list } from '@/api/trade_category'
import { oss_token_list } from '@/api/oss_token'
import { user_list } from '@/api/user'
import { tradeUserList } from '@/api/trade_user'
function getBase64 (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}
// 表单字段
const fields = ['id', 'host_corporation_id', 'category_id', 'number', 'name', 'credit', 'cash']
export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    }
    this.corporationSearch = debounce(this.handleCorporationSearch, 800)
    this.categorySearch = debounce(this.handleCategorySearch, 800)
    this.userSearch = debounce(this.handleUserSearch, 800)
    this.userLeaderSearch = debounce(this.handleUserLeaderSearch, 800)
    return {
      corporationList: [],
      categoryList: [],
      form: this.$form.createForm(this),
      data: {
        start_date: undefined,
        end_date: undefined,
        file_list: []
      },
      fileList: [],
      userList: [],
      userLeaderList: [],
      categoryTreeData: [],
      fetching: false,
      leaderFetching: false,
      categoryFetching: false,
      corporationFetching: false,
      previewVisible: false,
      previewImage: '',
      actionUrl: 'https://static2.jnzbtz.com',
      new_multipart_params: {
        'key': '',
        'policy': '',
        'OSSAccessKeyId': '',
        'success_action_status': '200',
        'signature': ''
      }
    }
  },
  created () {
    console.log('custom modal created', this.form)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    const date = new Date()
    const month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
    const day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
    const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
    const minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
    const number = { number: date.getFullYear() + '' + month + day + hours + minutes }
    const data = { ...this.model, ...number }
    this.model && this.form.setFieldsValue(pick(data, fields))
    this.initOss()
  },
  mounted () {
    this.handleDepartmentList()
  },
  methods: {
    async initOss () {
      this.new_multipart_params = await this.ossToken()
    },
    ossToken () {
      return new Promise((resolve, reject) => {
        oss_token_list().then(({ data }) => {
          const multipart_params = {
            OSSAccessKeyId: data.accessid,
            policy: data.policy,
            signature: data.signature
          }
          resolve(multipart_params)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    handleCorporationSearch (value) {
      if (value === undefined || value === '') {
        return
      }
      this.corporationFetching = true
      this.corporationList = []
      corporation_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.corporationList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      }).finally(() => {
        this.corporationFetching = false
      })
    },
    handleUserSearch (value) {
      if (value === undefined || value === '') {
        return
      }
      this.fetching = true
      this.userList = []
      if (this.userList.length > 0) {
        user_list({ nickname: value }).then((res) => {
          const result = res.data.entries || []
          this.userList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
        }).finally(() => {
          this.fetching = false
        })
      }
      tradeUserList({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.userList = result
      }).finally(() => {
        this.fetching = false
      })
    },
    handleUserLeaderSearch (value) {
      if (value === undefined || value === '') {
        return
      }
      this.leaderFetching = true
      this.userLeaderList = []
      tradeUserList({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.userLeaderList = result
      }).finally(() => {
        this.leaderFetching = false
      })
    },
    handleCategorySearch (value) {
      if (value === undefined || value === '') {
        return
      }
      this.categoryFetching = true
      this.categoryList = []
      category_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.categoryList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      }).finally(() => {
        this.categoryFetching = false
      })
    },
    onDateChange (date, dateString) {
      console.log(date, dateString)
      this.data.start_date = dateString[0]
      this.data.end_date = dateString[1]
    },
    beforeUpload (file) {
      const name = file.name
      const suffix = name.substring(name.lastIndexOf('.') + 1)
      const lastName = file.lastModified + '.' + suffix
      this.new_multipart_params.key = file.uid + '_' + lastName
      // const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      // if (!isJpgOrPng) {
      //   this.$message.error('你只能上传jpeg/png格式的图片')
      // }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件过大，请重新上传')
      }
      return isLt10M
    },
    async handlePreview (file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj, () => {
        })
      }
      console.log('我要预览', file)
      this.previewImage = file.url || file.preview || file.thumbUrl
      this.previewVisible = true
    },
    handleChange ({ fileList, file }) {
      this.fileList = fileList
      if (file.status === 'removed') {
        this.form.setFieldsValue({ decision_url: '' })
        this.$message.error('请重新上传')
        this.data.file_list = this.data.file_list.filter(item => {
          if (item.includes(file.lastModified)) {
            return false
          }
          return true
        })
      }
      if (file.status === 'done') {
        this.form.setFieldsValue({ decision_url: this.actionUrl + '/' + this.new_multipart_params.key })
        this.data.file_list.push(this.actionUrl + '/' + this.new_multipart_params.key)
      }
    },
    handleCancel: function () {
      this.previewVisible = false
    },
    handleDepartmentList () {
      category_list().then((res) => {
        const result = res.data.entries || []
        this.categoryTreeData = this.buildTree(this.transformCategories(result))
      })
    },
    transformCategories (categories) {
      return categories.map(category => ({
        title: category.name,
        value: category.id,
        key: category.id,
        parent_category_id: category.parent_category_id,
        remark: category.remark
      }))
    },
    buildTree (categories) {
      const idToNodeMap = {}
      const tree = []
      // 初始化每个节点
      categories.forEach(category => {
        idToNodeMap[category.key] = { ...category, children: [] }
      })
      // 构建树状结构
      categories.forEach(category => {
        const parentId = category.parent_category_id
        if (parentId === -1) {
          tree.push(idToNodeMap[category.key])
        } else {
          idToNodeMap[parentId].children.push(idToNodeMap[category.key])
        }
      })
      tree.forEach(node => {
        const children = node.children || []
        if (children.length > 0) {
          node['disabled'] = true
        } else {
          node['disabled'] = false
        }
      })
      return tree
    }
  }
}
</script>
